import { getLocaleFontInfo } from '@/translations';
import { resolveGameName } from './gameMapper';

// Assets groups
const reloadModalAssets = ['reloadModalBackground.png', 'reloadModalLogo.png'];
const generalUIAssets = ['generalUI.png', 'generalUI.json'];
const promotionAssets = ['promotionModalBackground.png', 'promotionModalText.fnt'];
const promotionManualAssets = ['promotionManualBackground.png', 'promotionManualButton.png', 'promotionManualButtonIcon.png'];
const sharedControls = ['sharedSpinButton.json', 'sharedStoreButton.json', 'sharedAutoplayButton.json', 'sharedDecreaseBetButton.json', 'sharedIncreaseBetButton.json', 'sharedCoinSound.mp3'];

// Games groups
const generalUIOnly = [
  'GoldOfEgypt',
  'RandysRevenge',
];

const generalUIAndPromo = [
  'Bandido',
  'CherryBlast',
  'DueloMahjong',
  'EmberInferno',
  'EmpireOfTheTiger',
  'FishyGuy',
  'JokersShow',
  'KraljBalkana',
  'NedAndTed',
  'PremierSlot',
  'SugarBlast',
  'Supernova',
  'TaleOfGems',
  'TolucaFortune',
];

const generalUIAndPromoManual = [
  'FishyCatch',
  'JokersFortune',
  'SuperCup',
];

const gamesThatUseSharedControls = [
  'DueloMahjong',
];

export function getCustomAssetsForGame(gameName) {
  const customAssets = [...reloadModalAssets];

  const game = resolveGameName(gameName);
  const customFontAssetName = getLocaleFontInfo()?.assetName;

  // Custom font
  if (customFontAssetName) {
    customAssets.push(customFontAssetName);
  }

  // Custom assets
  if (generalUIOnly.includes(game)) {
    customAssets.push(...generalUIAssets);
  } else if (generalUIAndPromo.includes(game)) {
    customAssets.push(...generalUIAssets, ...promotionAssets);
  } else if (generalUIAndPromoManual.includes(game)) {
    customAssets.push(...generalUIAssets, ...promotionAssets, ...promotionManualAssets);
  } else {
    customAssets.push(
      'jackpotWin.mp3',
      'iconLobby.png',
      'particleLine.png',
      'particleSpark.png',
      'progressScaleDefault.mp3',
      'progressMoveDefault.mp3',
      'progressWinDefault.mp3',
      'progressCompleteDefault.mp3',
      'reelBonusWaitDefault.mp3',
      'reelSpinDefault.mp3',
      'reelsMultiplierHit.mp3',
      ...promotionAssets,
    );
  }

  if (gamesThatUseSharedControls.includes(game)) {
    customAssets.push(...sharedControls);
  }

  return customAssets;
}
